import ReactDOM from "react-dom/client";
import { SnackbarProvider } from "notistack";
import { AppRouter } from "./AppRouter";
import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <SnackbarProvider>
    <AppRouter />
  </SnackbarProvider>
);
